import { navigate, RouteComponentProps } from '@reach/router';
import React, { Component } from 'react';

import { IErrorsActions } from '../../../store/errors/actions';
import { INotificationsActions } from '../../../store/notification/actions';
import { IClubsActions } from '../../../store/player/clubs/actions';
import { IMembershipsActions } from '../../../store/player/memberships/actions';
import { IProfileActions } from '../../../store/user/actions';

import { IMessageNotification } from '../../../store/notification/store';
import { IClubsStore } from '../../../store/player/clubs/store';
import { ISource, IStripeToken, IUserStore } from '../../../store/user/store';

import { withContext } from '../../../contrib/utils';

import Button from '../../../components/Button';
import JoinClubCta from '../../../components/JoinClubCta';
import PaymentHeader from '../../../components/PaymentHeader';
import PaymentManager from '../../../components/PaymentManager';

interface IProps extends RouteComponentProps {
  actions: {
    clubs: IClubsActions;
    errors: IErrorsActions;
    memberships: IMembershipsActions;
    notifications: INotificationsActions;
    user: IProfileActions;
  };
  clubId: number;
  clubs: IClubsStore;
  user: IUserStore;
}

export class ClubPayComponent extends Component<IProps, {}> {
  constructor(props: IProps) {
    super(props);

    this.next = this.next.bind(this);
  }

  public componentDidMount(): void {
    this.props.actions.clubs.get(this.props.clubId);
  }

  public async next(clubId: number, payment?: IStripeToken | ISource): Promise<any> {
    const { actions } = this.props;
    const response = await actions.memberships.create(clubId, payment);

    if (response.errors) {
      await actions.notifications.push(({
        status: 'unread',
        text: response.errors.memberships.msg,
        type: 'error'
      } as unknown) as IMessageNotification);
    } else {
      navigate(`/club/${clubId}`);
    }
  }

  public render(): JSX.Element {
    const { clubs, user } = this.props;
    const club = clubs[Number(this.props.clubId)];

    return (
      <div className="club-pay wrapper">
        {!!club ? (
          club.processPayment ? (
            <div>
              <PaymentHeader powered={false} club={club} />
              <PaymentManager
                actions={this.props.actions}
                clubId={this.props.clubId}
                user={user}
                nextButton={'NEXT'}
                next={this.next}
              />
              <div className="decline-button-container override">
                <Button color="primary" type="submit" className="button decline" id="decline">
                  DECLINE INVITE
                </Button>
              </div>
            </div>
          ) : (
            <JoinClubCta club={club} clubId={this.props.clubId} next={this.next} />
          )
        ) : null}
      </div>
    );
  }
}

const ClubPay = withContext(ClubPayComponent, 'user', 'clubs');

export { ClubPay };
